<template>
  <section class="summary-section" :class="{ 'is-active': isActive }">
    <!-- 배경 이미지 (풀스크린) -->
    <div class="bg-image">
      <img :src="heroImg" alt="투시도" />
      <div class="bg-overlay"></div>
    </div>

    <!-- 우측 상단 SUMMARY + 필기체 -->
    <div class="right-title">
      <h2 class="big-title anim-right" :class="{ show: isActive }" style="--delay: 0.3s">SUMMARY</h2>
      <span class="script-text anim-right" :class="{ show: isActive }" style="--delay: 0.5s">Ecofore, a Pride of Gimcheon-Gumi</span>
    </div>

    <!-- 사업개요 그리드 -->
    <div class="info-grid">
      <div class="info-item anim" :class="{ show: isActive }" style="--delay: 0.6s">
        <span class="info-label">대지위치</span>
        <span class="info-value">경상북도 김천시 아포읍 국사리 산8-3 일원</span>
      </div>
      <div class="info-item anim" :class="{ show: isActive }" style="--delay: 0.7s">
        <span class="info-label">대지면적</span>
        <span class="info-value">31,835.00㎡ (9,630.09평)</span>
      </div>
      <div class="info-item anim" :class="{ show: isActive }" style="--delay: 0.8s">
        <span class="info-label">건축면적</span>
        <span class="info-value">7,360.25㎡ (건폐율 23.12%)</span>
      </div>
      <div class="info-item anim" :class="{ show: isActive }" style="--delay: 0.9s">
        <span class="info-label">규모</span>
        <span class="info-value">지하 2층 ~ 지상 29층 / 7개동 / 총 736세대(예정)</span>
      </div>
      <div class="info-item anim" :class="{ show: isActive }" style="--delay: 1.0s">
        <span class="info-label">용적률</span>
        <span class="info-value">249.36%</span>
      </div>
      <div class="info-item anim" :class="{ show: isActive }" style="--delay: 1.1s">
        <span class="info-label">주차대수</span>
        <span class="info-value">총 939대 (세대당 1.28대)</span>
      </div>
    </div>

    <!-- 하단 주의문구 -->
    <div class="disclaimer anim" :class="{ show: isActive }" style="--delay: 1.2s">
      <div class="notice-item">
        <span class="notice-icon">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
        </span>
        <p>상기 CG는 소비자의 이해를 돕기 위한 것으로 실제와 차이가 날 수 있으며, 건축물의 외관 및 색채계획, 경관조명계획, 부대시설, 창호계획, 조경계획, 문주 등의 기타시설은 추후 변경될 수 있습니다. 또한 조경 시설물과 식재는 실제와 다를 수 있습니다.</p>
      </div>
      <div class="notice-item">
        <span class="notice-icon">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
        </span>
        <p>단지를 제외한 기타 배경(산, 조명, 외부식재, 도로, 건물 등)은 소비자의 이해를 돕기 위한 참고 이미지를 활용하였으며 실제와 다를 수 있습니다.</p>
      </div>
    </div>
  </section>
</template>

<script>
import heroImg from '@/assets/hero/hero2.jpg'

export default {
  name: 'SummarySection',
  props: {
    isActive: { type: Boolean, default: false }
  },
  data() {
    return { heroImg }
  }
}
</script>

<style scoped>
.summary-section {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
  background: #101820;
}

/* ===== 애니메이션 ===== */
.anim {
  opacity: 0;
  transform: translateY(24px);
  transition: opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1),
              transform 0.8s cubic-bezier(0.16, 1, 0.3, 1);
  transition-delay: var(--delay, 0s);
}

.anim.show {
  opacity: 1;
  transform: translateY(0);
}

/* ===== 배경 이미지 ===== */
.bg-image {
  position: absolute;
  inset: 0;
  z-index: 0;
}

.bg-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.bg-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.82);
}

/* ===== 오른쪽에서 흐르듯이 ===== */
.anim-right {
  opacity: 0;
  transform: translateX(200px);
  transition: opacity 1.2s cubic-bezier(0.16, 1, 0.3, 1),
              transform 1.2s cubic-bezier(0.16, 1, 0.3, 1);
  transition-delay: var(--delay, 0s);
}

.anim-right.show {
  opacity: 1;
  transform: translateX(0);
}

/* ===== 우측 타이틀 영역 ===== */
.right-title {
  position: absolute;
  top: 16%;
  right: 8%;
  z-index: 10;
  text-align: right;
}

.big-title {
  font-family: var(--font-serif);
  font-size: clamp(72px, 7vw, 120px);
  font-weight: 800;
  letter-spacing: 6px;
  color: rgba(255, 255, 255, 0.9);
  margin: 0 0 16px;
  display: block;
}

.script-text {
  font-family: var(--font-script);
  font-size: clamp(28px, 2.5vw, 42px);
  color: rgba(255, 255, 255, 0.35);
  white-space: nowrap;
  display: block;
}

/* ===== 사업개요 그리드 ===== */
.info-grid {
  position: absolute;
  left: 8%;
  bottom: 18%;
  z-index: 10;
  display: grid;
  grid-template-columns: repeat(3, 240px);
  gap: 0;
}

.info-item {
  padding: 22px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.info-label {
  display: block;
  font-family: var(--font-pretendard);
  font-size: 15px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: 14px;
}

.info-value {
  display: block;
  font-family: var(--font-pretendard);
  font-size: 13px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.45);
  line-height: 1.6;
}

/* ===== 하단 주의문구 ===== */
.disclaimer {
  position: absolute;
  bottom: 28px;
  left: 8%;
  right: 8%;
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.notice-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.notice-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.35);
  flex-shrink: 0;
  margin-top: 2px;
}

.disclaimer p {
  font-family: var(--font-pretendard);
  font-size: 11px;
  color: rgba(255, 255, 255, 0.35);
  line-height: 1.7;
  margin: 0;
  word-break: keep-all;
}

/* ===== 반응형 ===== */

/* --- 1200px: 중간 데스크탑 --- */
@media (max-width: 1200px) {
  .info-grid {
    grid-template-columns: repeat(3, 200px);
  }
  .info-item {
    padding: 18px 20px;
  }
}

/* --- 1024px: 태블릿 --- */
@media (max-width: 1024px) {
  .right-title {
    top: 10%;
    right: 6%;
  }

  .big-title {
    font-size: clamp(48px, 6vw, 80px);
    letter-spacing: 4px;
    margin-bottom: 12px;
  }

  .script-text {
    font-size: clamp(22px, 2.2vw, 32px);
  }

  .info-grid {
    left: 6%;
    bottom: 16%;
    grid-template-columns: repeat(2, 1fr);
    right: 6%;
    width: auto;
  }

  .info-item {
    padding: 18px 20px;
  }

  .info-label {
    font-size: 14px;
    margin-bottom: 10px;
  }

  .info-value {
    font-size: 12.5px;
  }

  .disclaimer {
    left: 6%;
    right: 6%;
    bottom: 20px;
  }

  .disclaimer p {
    font-size: 10.5px;
  }

  .anim-right {
    transform: translateX(120px);
  }

  .anim-right.show {
    transform: translateX(0);
  }
}

/* --- 768px: 모바일 --- */
@media (max-width: 768px) {
  .summary-section {
    height: 100vh;
    min-height: 600px;
  }

  .right-title {
    position: absolute;
    top: auto;
    bottom: auto;
    top: 8%;
    right: auto;
    left: 20px;
    right: 20px;
    text-align: left;
  }

  .big-title {
    font-size: clamp(36px, 10vw, 56px);
    letter-spacing: 3px;
    margin-bottom: 8px;
  }

  .script-text {
    font-size: clamp(16px, 4vw, 24px);
    white-space: normal;
    color: rgba(255, 255, 255, 0.55);
  }

  .info-grid {
    position: absolute;
    left: 20px;
    right: 20px;
    bottom: 14%;
    width: auto;
    grid-template-columns: repeat(2, 1fr);
    gap: 0;
  }

  .info-item {
    padding: 14px 16px;
  }

  .info-label {
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 8px;
    color: rgba(255, 255, 255, 0.95);
  }

  .info-value {
    font-size: 13.5px;
    line-height: 1.6;
    color: rgba(255, 255, 255, 0.7);
  }

  .disclaimer {
    left: 20px;
    right: 20px;
    bottom: 16px;
  }

  .disclaimer p {
    font-size: 11px;
    line-height: 1.6;
    color: rgba(255, 255, 255, 0.35);
  }

  /* 모바일 애니메이션: 작은 이동값 */
  .anim {
    transform: translateY(16px);
  }

  .anim.show {
    transform: translateY(0);
  }

  .anim-right {
    transform: translateX(60px);
  }

  .anim-right.show {
    transform: translateX(0);
  }
}

/* --- 480px: 소형 모바일 --- */
@media (max-width: 480px) {
  .right-title {
    top: 7%;
    left: 20px;
    right: 20px;
  }

  .big-title {
    font-size: clamp(28px, 9vw, 42px);
    letter-spacing: 2px;
    margin-bottom: 6px;
  }

  .script-text {
    font-size: clamp(14px, 3.8vw, 20px);
  }

  .info-grid {
    left: 20px;
    right: 20px;
    bottom: 12%;
    grid-template-columns: 1fr;
  }

  .info-item {
    padding: 12px 14px;
  }

  .info-label {
    font-size: 14px;
    margin-bottom: 6px;
  }

  .info-value {
    font-size: 12.5px;
  }

  .disclaimer {
    left: 20px;
    right: 20px;
    bottom: 12px;
  }

  .disclaimer p {
    font-size: 10px;
  }
}
</style>
